import React from 'react';
import classNames from 'classnames';
import { string, func, bool } from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { UI_MODES } from '../../constants';

import './style.scss';

const SubmitButton = ({ onSubmit, mode, disabled, isLoading }) => {
    const getLabelKey = (mode) => {
        switch (mode) {
            case UI_MODES.EDIT:
                return 'layout.global_messages.user_activation.update_and_resend';
            default:
                return 'layout.global_messages.user_activation.resend_email';
        }
    };

    const classes = classNames('submit', {
        'loading': isLoading
    });

    return (
        <div className={classNames('cta-container', 'tbody-6')}>
            <Button className={classes}
                color={Button.COLORS.WHITE}
                fill={Button.FILLS.FULL}
                textColor={Button.TEXT_COLORS.DARK_GREY}
                loading={isLoading}
                disabled={disabled}
                onClick={onSubmit}>
                <I18n k={getLabelKey(mode)}/>
            </Button>
        </div>
    );
};

SubmitButton.propTypes = {
    onSubmit: func,
    isLoading: bool.isRequired,
    mode: string.isRequired,
    disabled: bool.isRequired
};

export default SubmitButton;
